<template>
  <div class="view-wrapper" :class="{ 'embedded-mode': embeddedMode }">
    <template>
      <div v-if="showToolbar" class="search-bar-list pd-btm0">
        <swipeBack
          v-if="showHeaderBar"
          :title="title"
          :backtxt="$t('back')"
          @backFn="backFn"
        />
        <div class="tab-container" style="width: 100%;">
          <div class="custom-tabs">
            <template v-if="isGA">
              <div
                class="tab-item"
                :class="{ active: activeTab === '1' }"
                @click="changeTab('1')"
              >
                {{ $t('he_expert') }}
              </div>
              <div
                class="tab-item"
                :class="{ active: activeTab === '0' }"
                @click="changeTab('0')"
              >
                {{ $t('clinical_doctor') }}
              </div>
            </template>
            <template v-else>
              <div
                class="tab-item"
                :class="{ active: activeTab === '0' }"
                @click="changeTab('0')"
              >
                {{ $t('clinical_doctor') }}
              </div>
              <div
                class="tab-item"
                :class="{ active: activeTab === '1' }"
                @click="changeTab('1')"
              >
                {{ $t('he_expert') }}
              </div>
            </template>
          </div>
        </div>
        <div v-if="showSearchFilter" class="search-filter">
          <div class="custom-search-bar" @click="showFilterPopup = true">
            <van-icon name="search" class="search-icon" />
            <div class="search-content">
              <span v-if="!filterParams.search_key && displayTags.length === 0" style="color: #999">{{ $t('click_to_search_filter') }}</span>
              <span v-if="filterParams.search_key" style="margin-right: 5px">{{ filterParams.search_key }}</span>
              <span v-for="(tag, index) in displayTags" :key="index" class="search-tag">{{ tag }}</span>
            </div>
            <div class="divider"></div>
            <div class="reset-action" @click.stop="showFilterPopup = true">
              <van-icon name="filter-o" class="reset-icon" />
              <span>{{ $t('filter') }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- Loading State -->
      <div v-if="loading && list.length === 0" class="loading-state">
        <van-loading type="spinner" color="#999" vertical />
      </div>
      <!-- Empty State -->
      <van-empty
        v-else-if="activeTab === '0' && !loading && list.length === 0"
        :description="$t('no_clinical_doctor')"
        image="/image/empty.png"
      />
      <van-empty
        v-else-if="activeTab === '1' && !loading && list.length === 0"
        :description="$t('no_he_expert')"
        image="/image/empty.png"
      />
      <div
        v-show="list.length > 0"
        class="index-list-wrapper index-list-wrapper-gba custom"
        :class="{
          'no-list': list.length == 0,
          'index-list-wrapper-nosales': !isSales,
        }"
        :style="{ backgroundColor: embeddedMode ? 'transparent' : '#f2f5f9' }"
      >
        <div class="hospital-count-div" :class="{ embedded: embeddedMode }">
          <span class="hospital-count-item">{{ $t('doctor_count') }}<span class="f-blod">{{ physician_count }}</span></span>
        </div>
        <van-list
          v-model="listLoading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('no_more_txt')"
          @load="onLoad"
        >
          <CardItem
            v-for="(item, $index) in list"
            :id="'ITEM' + $index"
            :ref="$index == 0 ? 'AIMREF' : ''"
            :key="item.product_id + '_' + item.physician_id + $index"
            :class="{ 'embedded-card': embeddedMode }"
            :style="
              selectedItems?.includes?.(item.physician_id)
                ? {border: '1px solid #aa341b'}
                : {}
            "
            :is-favorite="true"
            :gen-status="false"
            :show-draw="false"
            :item="item"
            :hide-visit-button="!!onSelectItem"
            :parting="item.result"
            :physician-segment="item.physician_segment"
            @refreshFn="pageFn"
            @clickItem="selectItem(item)"
          />
        </van-list>
        <div :style="{ height: embeddedMode ? '0' : '50px' }"></div>
      </div>
    </template>
    <popup
      v-if="showDescStatus"
      :title="searchDesc"
      @closeFn="showDescStatus = false"
    >
      <div class="box" style="max-height: 400px; overflow-y: auto">
        <div class="seg-type-desc box">
          <div class="seg-type-list">
            <p v-if="searchDesc == $t('search_desc_title')">
              <!-- <span class="td-title">{{ $t('search_desc_title') }}：</span> -->
              <span class="td-value">
                {{ $t('search_desc_content') }}
              </span>
            </p>
            <template v-if="searchDesc == $t('sort_desc_title')">
              <p>
                <span class="td-title">{{ $t('sort_by_name') }}</span>
                <span class="td-value">{{ $t('sort_by_name_desc') }}</span>
              </p>
              <p>
                <span class="td-title">{{ $t('sort_by_hospital') }}</span>
                <span class="td-value">{{ $t('sort_by_hospital_desc') }}</span>
              </p>
              <p>
                <span class="td-title">{{ $t('sort_by_level') }}</span>
                <span class="td-value">
                  {{ $t('sort_by_level_desc') }}
                </span>
              </p>
            </template>
          </div>
        </div>
      </div>
    </popup>
    <!-- filter popup -->
    <van-popup
      v-if="showSearchFilter"
      v-model="showFilterPopup"
      position="left"
      closeable
      style="width: 70%"
    >
      <div class="filter-popup">
        <van-form>
          <van-field
            ref="searchInput"
            v-model="filterParams.search_key"
            :label="$t('search_keyword')"
            :placeholder="$t('enter_keyword')"
          >
            <template #label>
              <div class="field-label">{{ $t('search_keyword') }}</div>
            </template>
          </van-field>

          <van-field :label="$t('is_favorite')">
            <template #label>
              <div class="field-label">{{ $t('is_favorite') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.is_favorite">
                <van-checkbox
                  v-for="opt in commonOptions"
                  :key="opt.value"
                  :name="opt.value"
                >{{ opt.text }}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>

          <van-field :label="$t('is_covered')">
            <template #label>
              <div class="field-label">{{ $t('is_covered') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.is_covered">
                <van-checkbox
                  v-for="opt in commonOptions"
                  :key="opt.value"
                  :name="opt.value"
                >{{ opt.text }}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>

          <van-field :label="$t('is_wechat_bound')">
            <template #label>
              <div class="field-label">{{ $t('is_wechat_bound') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.is_wechat">
                <van-checkbox
                  v-for="opt in commonOptions"
                  :key="opt.value"
                  :name="opt.value"
                >{{ opt.text }}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>

          <van-field :label="$t('is_consent_signed')">
            <template #label>
              <div class="field-label">{{ $t('is_consent_signed') }}</div>
            </template>
            <template #input>
              <van-checkbox-group v-model="filterParams.is_consent">
                <van-checkbox
                  v-for="opt in commonOptions"
                  :key="opt.value"
                  :name="opt.value"
                >{{ opt.text }}</van-checkbox>
              </van-checkbox-group>
            </template>
          </van-field>

          <van-field>
            <template #input>
              <div
                style="
                  margin-top: 40px;
                  width: 100%;
                  display: flex;
                  justify-content: center;
                "
              >
                <van-button
                  round
                  type="info"
                  class="search-filter-button"
                  color="#aa341b"
                  style="height: 40px"
                  @click="confirmFilter"
                >{{ $t('confirm_txt') }}</van-button>
                <van-button
                  round
                  plain
                  type="info"
                  class="search-filter-button"
                  color="#aa341b"
                  style="height: 40px; margin-left: 20px"
                  @click="resetFilter"
                >{{ $t('reset') }}</van-button>
              </div>
            </template>
          </van-field>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { getUserTa } from '@/api/user';
import * as py from '@/api/Physicians';
import popup from '@/views/layout/popup';
import swipeBack from '@/views/layout/swipeBack';
import {
  List,
  Search,
  DropdownMenu,
  DropdownItem,
  Button,
  Collapse,
  CollapseItem,
  RadioGroup,
  Radio,
  Icon,
  Popup,
  Form,
  Field,
  Checkbox,
  CheckboxGroup,
  Empty,
  Loading
} from 'vant';
import {
  getFirstUpperChar,
  getLocalStorage,
  setLocalStorage,
  debounce,
} from '@/utils/index';
import _ from 'underscore';
// import followBscMIxin from "@/mixins/followBscMIxin";
import refreshUserID from '@/mixins/refreshUserID';
import CardItem from '@/views/hcp/components/CardItem';
import SummaryChart from '@/components/SummaryChart';
import CommonHeader from '@/components/CommonHeader';

export default {
  components: {
    CardItem,
    popup,
    swipeBack,
    vanList: List,
    // vanSearch: Search,
    vanButton: Button,
    vanIcon: Icon,
    vanPopup: Popup,
    vanForm: Form,
    vanField: Field,
    vanCheckbox: Checkbox,
    vanCheckboxGroup: CheckboxGroup,
    vanEmpty: Empty,
    vanLoading: Loading,
    // CommonHeader,
  },
  mixins: [refreshUserID],
  props: {
    onSelectItem: {
      type: Function,
    },
    embeddedMode: {
      type: Boolean,
      default: false,
    },
    forcedActiveTab: {
      type: String,
      default: '',
    },
    syncRouteTab: {
      type: Boolean,
      default: true,
    },
    selectedItems: {
      type: Array,
      default() {
        return [];
      },
    },
    externalItems: {
      type: Array,
      default: null,
    },
  },
  data() {
    const roleName = getLocalStorage('role_name');
    const isGA = roleName === 'GA';
    return {
      isGA: isGA,
      activeTab: isGA ? '1' : '0',
      pageName: 'doctorList',
      sortOrder: 'physician_name',
      activeTxt: 'other',
      isHcpHeader: 0,
      keyword: '',
      loading: false,
      singerData: [], // 结构数据
      initList: [], // 初始数据
      list: [],
      listLoading: false,
      finished: false,
      pageNum: 1,
      searchKey: '',
      isSearch: false,
      loadingTxt: this.$t('loading_txt'),
      physician_count: 0,
      ex_data_support_count: 0,
      is_wechat_count: 0,
      showProduct: [{text: this.$t('all_products'), value: ''}],
      productParting: [
        {
          product: 'Azilect',
          parting: [
            {
              text: '长期获益 - 一线',
              value: '长期获益 - 一线',
            },
            {
              text: '长期获益 - 认可',
              value: '长期获益 - 认可',
            },
            {
              text: '长期获益 - 尝试',
              value: '长期获益 - 尝试',
            },
            {
              text: '症状控制 - 初识',
              value: '症状控制 - 初识',
            },
          ],
        },
        {
          product: 'Brintellix',
          parting: [
            {
              text: '信心满满',
              value: '信心满满',
            },
            {
              text: '功能恢复',
              value: '功能恢复',
            },
            {
              text: '全面症状',
              value: '全面症状',
            },
            {
              text: '情感驱动',
              value: '情感驱动',
            },
          ],
        },
        {
          product: 'Ebixa',
          parting: [
            {
              text: '高认可度 已完成/政策宽松',
              value: '高认可度 已完成/政策宽松',
            },
            {
              text: '高认可度 指标远未完成/政策限制严格',
              value: '高认可度 指标远未完成/政策限制严格',
            },
            {
              text: '高认可度 医院停控药',
              value: '高认可度 医院停控药',
            },
            {
              text: '中认可度 已完成/政策宽松',
              value: '中认可度 已完成/政策宽松',
            },
            {
              text: '中认可度 指标远未完成/政策限制严格',
              value: '中认可度 指标远未完成/政策限制严格',
            },
            {
              text: '中认可度 医院停控药',
              value: '中认可度 医院停控药',
            },
            {
              text: '低认可度 已完成/政策宽松',
              value: '低认可度 已完成/政策宽松',
            },
            {
              text: '低认可度 指标远未完成/政策限制严格',
              value: '低认可度 指标远未完成/政策限制严格',
            },
            {
              text: '低认可度 医院停控药',
              value: '低认可度 医院停控药',
            },
          ],
        },
        {
          product: 'Lexapro',
          parting: [
            {
              text: '高认可医生',
              value: '高认可医生',
            },
            {
              text: '低认可医生',
              value: '低认可医生',
            },
          ],
        },
      ],
      showProductParting: [{text: this.$t('all_segments'), value: ''}],
      selectedProduct: '',
      selectedParting: '',
      searchDisable: false,
      resetDisable: false,
      summaryData: [],
      activeNames: '',
      isSales: null,
      loadUrl: null,
      showDescStatus: false,
      isMr: false,
      searchDesc: this.$t('search_desc_title'), // 排序说明
      title: '', // 医生列表
      showFilterPopup: false,
      filterParams: {
        search_key: '',
        is_favorite: [],
        is_covered: [],
        is_wechat: [],
        is_consent: []
      },
      commonOptions: [
        { text: this.$t('yes'), value: true },
        { text: this.$t('no'), value: false }
      ],
      requestSeq: 0,
      activeRequestSeq: 0,
    };
  },
  computed: {
    showToolbar() {
      return !this.embeddedMode;
    },
    showSearchFilter() {
      return !this.embeddedMode;
    },
    hasActiveFilter() {
      const f = this.filterParams;
      return (
        f.search_key ||
        (f.is_favorite && f.is_favorite.length > 0) ||
        (f.is_covered && f.is_covered.length > 0) ||
        (f.is_wechat && f.is_wechat.length > 0) ||
        (f.is_consent && f.is_consent.length > 0)
      );
    },
    displayTags() {
      const tags = [];
      const fp = this.filterParams;

      const getTag = (arr, trueText, falseText) => {
        if (arr && arr.length === 1) {
          return arr[0] === true ? trueText : falseText;
        }
        return null;
      };

      const fav = getTag(fp.is_favorite, this.$t('favorite'), this.$t('not_favorite'));
      if (fav) tags.push(fav);

      const cov = getTag(fp.is_covered, this.$t('covered'), this.$t('not_covered'));
      if (cov) tags.push(cov);

      const wechat = getTag(fp.is_wechat, this.$t('wechat_bound'), this.$t('wechat_not_bound'));
      if (wechat) tags.push(wechat);

      const consent = getTag(fp.is_consent, this.$t('consent_signed'), this.$t('consent_not_signed'));
      if (consent) tags.push(consent);

      return tags;
    },
    showHeaderBar() {
      if (this.$route.name !== 'list') {
        return false;
      } else {
        return true;
      }
    },
    useExternalItems() {
      return Array.isArray(this.externalItems);
    },
  },
  watch: {
    externalItems() {
      if (this.useExternalItems) {
        this.applyExternalItems();
      }
    },
    forcedActiveTab(val) {
      const nextTab = this.normalizeActiveTab(val);
      if (!nextTab || nextTab === this.activeTab) {
        return;
      }
      this.activeTab = nextTab;
      if (this.useExternalItems) {
        this.applyExternalItems();
      } else {
        this.reset();
      }
    },
    showFilterPopup(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.searchInput && this.$refs.searchInput.focus();
        });
      }
    }
  },
  created() {
    const forcedTab = this.normalizeActiveTab(this.forcedActiveTab);
    const routeActiveTab = this.normalizeActiveTab(this.$route.query.activeTab);
    const initialTab = forcedTab || routeActiveTab;

    if (initialTab) {
      this.activeTab = initialTab;
    }
    if (this.syncRouteTab && !this.embeddedMode) {
      this.syncActiveTabQuery(this.activeTab);
    }

    try {
      const cached = sessionStorage.getItem('gba_doctor_list_filter');
      if (cached) {
        this.filterParams = JSON.parse(cached);
      }
    } catch (e) {
      console.log(e);
    }

    if (this.$route.query.department_name) {
      this.title = this.$route.query.department_name;
    }
    if (this.$route.query.institution_name) {
      this.title = this.title
        ? this.title + ' - ' + this.$route.query.institution_name
        : this.$route.query.institution_name;
    }
    if (
      getLocalStorage('territory_type') &&
      getLocalStorage('territory_type') === 'MR'
    ) {
      this.isMr = true;
    }
    if (this.useExternalItems) {
      this.applyExternalItems();
    } else {
      this.getUserId();
    }
    // this.initPage(getLocalStorage("user_id"));
  },
  mounted() {},
  methods: {
    normalizeActiveTab(value) {
      const tab = String(value || '');
      return ['0', '1'].includes(tab) ? tab : '';
    },
    syncActiveTabQuery(tab) {
      if (!this.syncRouteTab || this.embeddedMode) {
        return;
      }
      if (this.$route.query.activeTab === tab) {
        return;
      }

      this.$router.replace({
        path: this.$route.path,
        query: {
          ...this.$route.query,
          activeTab: tab,
        },
      });
    },
    backFn() {
      if (this.$route.query.routeTxt === 'department') {
        // 返回科室
        this.$router.push({
          path: '/kol/department',
          query: {
            user_id: getLocalStorage('user_id'),
            institution_id: this.$route.query.institution_id,
            tab_state: this.$route.query.tab_state,
            institution_name: this.$route.query.institution_name,
          },
        });
      } else {
        // 返回首页  (this.$route.query.routeTxt === 'home')
        this.$router.push({
          path: '/kol/home',
          query: {
            user_id: getLocalStorage('user_id_key'),
            tab_state: this.$route.query.tab_state,
          },
        });
      }
    },
    changeTab(val) {
      const nextTab = this.normalizeActiveTab(val) || this.activeTab;
      const hasChanged = this.activeTab !== nextTab;

      this.syncActiveTabQuery(nextTab);

      if (!hasChanged) {
        return;
      }

      this.activeTab = nextTab;
      this.reset();
    },
    showDescFn(status) {
      this.searchDesc = status === 1 ? this.$t('search_desc_title') : this.$t('sort_desc_title');
      this.showDescStatus = true;
    },
    closeWXWindow() {
      window.history.pushState(null, null, document.URL);
    },
    initPage(userId) {
      // if (this.isSales || this.isSales === 0) {
      //   this.list = [];
      //   this.getShowProduct(userId);
      //   this.getTerritorieInfo(userId);
      //   this.pageFn(true);
      // } else {
      //   this.getIsSales(userId);
      // }
      this.list = [];
      this.pageFn(true);
    },
    applyExternalItems() {
      const items = this.sortNameFn([...(this.externalItems || [])]);
      this.list = items;
      this.initList = JSON.parse(JSON.stringify(items));
      this.physician_count = items.length;
      this.loading = false;
      this.listLoading = false;
      this.finished = true;
      this.pageNum = 1;
    },
    getShowProduct(userId) {
      py.getUserProduct(userId).then((res) => {
        if (res && res.value.length) {
          this.showProduct = [{text: this.$t('all_products'), value: ''}];
          res.value.map((item) => {
            this.showProduct.push({
              text: item.product_name,
              value: item.product_id,
            });
          });
        }
      });
    },
    getShowPating() {
      this.showProductParting = [{text: this.$t('all_segments'), value: ''}];
      if (this.selectedProduct) {
        let tempParting = this.productParting.find(
          (item) => this.selectedProduct.indexOf(item.product) > -1,
        );
        if (tempParting) {
          this.showProductParting.push(...tempParting.parting);
        }
      }
    },
    changeProduct() {
      this.selectedParting = '';
      if (!this.selectedProduct) {
        this.sortOrder = 'physician_name';
      }
      this.getShowPating();
    },
    getTerritorieInfo(userId) {
      this.getTerritoryTypingKpi(getLocalStorage('territory_id'));
    },
    sortNameFn(arr) {
      const listDataMap = _.groupBy(arr, (ele) => {
        ele.name = getFirstUpperChar(ele.physician_name);
        return ele.name;
      });
      let mapArr = [];
      for (let key in listDataMap) {
        mapArr.push({
          name: key,
          items: listDataMap[key],
        });
      }
      const sortArr = _.sortBy(mapArr, 'name');
      let list = [];
      sortArr.forEach((ele) => {
        list = list.concat(ele.items);
      });
      return list;
    },
    dealListData(arr) {
      let concatArr = [];
      // if (this.isSearch) {
      //   // 搜索
      //   concatArr = arr;
      // } else {
      //   concatArr = this.list.concat(arr);
      // }
      let topArr = [];
      let noTopArr = [];
      arr.forEach((item) => {
        if (item.is_top) {
          topArr.push(item);
        } else {
          noTopArr.push(item);
        }
      });
      // 置顶数据
      const TopData = this.sortNameFn(topArr); // .sortBy(mapArr, 'name');
      // 未置顶数据
      const noTopDataOld = this.sortNameFn(noTopArr); // .sortBy(mapArr, 'name');
      const noTopData = noTopDataOld.sort((a, b) => {
        return a.name - b.name;
      });
      // this.list = [];
      const list = TopData.concat(noTopData);
      this.list = list;
      if (!this.isSearch) {
        this.initList = list;
      }
      this.loading = false;
    },
    isLatestRequest(requestSeq) {
      return requestSeq === this.activeRequestSeq;
    },
    // isSearch true 点击搜索时触发查询数量
    pageFn(isSearch) {
      if (this.useExternalItems) {
        this.applyExternalItems();
        return;
      }
      // Use keyword from filterParams if searching via filter
      if (isSearch) {
        this.keyword = this.filterParams.search_key;
      }

      let data = {
        user_id: getLocalStorage('user_id'),
        page_index: this.pageNum,
        page_size: 20,
        search_key: this.keyword,
        product_ids: this.selectedProduct,
        hcp_segments: this.selectedParting,
        institution_id: this.$route.query.institution_id,
        department_name: this.$route.query.department_name,
        hcp_category: this.activeTab === '1' ? 'expert' : undefined,
        ...this.filterParams
      };

      if (getLocalStorage('tas')) {
        data.tas = getLocalStorage('tas');
      }

      if (
        this.pageNum - 1 === 0 ||
        (this.pageNum - 1) * data.page_size < this.physician_count
      ) {
        this.loading = true;
        const requestSeq = ++this.requestSeq;
        this.activeRequestSeq = requestSeq;

        py.newGetPhysicianList(data, this.sortOrder)
          .then((res) => {
            if (!this.isLatestRequest(requestSeq)) {
              return;
            }
            this.loadList(res, isSearch);
          })
          .catch((e) => {
            if (!this.isLatestRequest(requestSeq)) {
              return;
            }
            this.claerData();
          });
      } else {
        this.listLoading = false;
        this.finished = true;
      }
    },
    // debouncePageFn: _.debounce(function () {
    //   this.pageFn();
    // }, 500),
    loadList(aRes, isSearch) {
      let res = aRes;
      if (res && res.isSuccess) {
        if (res && res.data_count) {
          this.physician_count = res.data_count;
        }
        let resArr = res.data;
        if (resArr && resArr.length > 0) {
          resArr.forEach((ele) => {
            this.list.push(ele);
          });
        }
        this.initList = JSON.parse(JSON.stringify(this.list));
        // 判断是否全部加载完成
        if (this.list.length >= this.physician_count) {
          this.finished = true;
        }
      } else {
        this.physician_count = 0;
        this.list = [];
        // this.loading = false;
        if (!this.isSearch) {
          // 非搜索
          this.finished = true;
        }
        this.isSearch = false;
      }
      this.loading = false;
      this.listLoading = false;
      this.searchDisable = false;
      this.resetDisable = false;
    },
    claerData() {
      this.listLoading = false;
      this.loading = false;
      this.isSearch = false;
      this.searchDisable = false;
      this.resetDisable = false;
      this.list = [];
    },

    onLoad() {
      if (this.useExternalItems) {
        this.finished = true;
        this.listLoading = false;
        return;
      }
      if (!this.loading) {
        this.pageNum++;
        this.listLoading = true;
        this.pageFn();
      }
    },
    refreshFn() {
      this.list = [];
      this.pageFn();
    },
    selectItem(item) {
      if (this.onSelectItem) {
        console.log(item, 'item');
        this.onSelectItem(item);
        return;
      }
      const isExpert = this.activeTab === '1' || item.hcp_category === 'expert';
      this.$router.push({
        path: isExpert ? '/gba/expert-detail' : '/gba/detail',
        query: {
          physician_id: item.physician_id,
          user_id: this.$route.query.user_id || getLocalStorage('user_id_key'),
          selectedLabel: isExpert ? 'aiSummary' : 'persona',
          activeTab: this.activeTab,
          institution_id: this.$route.query.institution_id,
          institution_name: this.$route.query.institution_name,
          routeTxt: this.$route.query.routeTxt,
          tab_state: this.$route.query.tab_state,
          department_name: this.$route.query.department_name,
        },
      });
    },
    searchDoctor() {
      const wrapper = this.$el.querySelector('.index-list-wrapper');
      if (wrapper) {
        wrapper.scrollTop = 0;
      }
      this.physician_count = 0;
      this.ex_data_support_count = 0;
      this.is_wechat_count = 0;
      this.list = [];
      this.pageNum = 1;
      this.finished = false;
      this.listLoading = false;
      this.isSearch = true;
      this.searchKey = this.keyword;
      this.resetDisable = true;
      this.pageFn(true);
    },
    reset() {
      this.physician_count = 0;
      this.ex_data_support_count = 0;
      this.is_wechat_count = 0;
      this.sortOrder = 'physician_name';
      this.list = [];
      this.pageNum = 1;
      this.finished = false;
      this.keyword = '';
      this.searchKey = '';
      this.selectedProduct = '';
      this.selectedParting = '';
      this.searchDisable = true;
      this.showProductParting = [{text: this.$t('all_segments'), value: ''}];
      if (this.useExternalItems) {
        this.applyExternalItems();
      } else {
        this.pageFn(true);
      }
    },

    getCurrentProduct() {
      let currentProduct = '';
      if (this.selectedProduct.indexOf('Azilect') > -1) {
        currentProduct = 'Azilect';
      } else if (this.selectedProduct.indexOf('Brintellix') > -1) {
        currentProduct = 'Brintellix';
      } else if (this.selectedProduct.indexOf('Ebixa') > -1) {
        currentProduct = 'Ebixa';
      } else if (this.selectedProduct.indexOf('Lexapro') > -1) {
        currentProduct = 'Lexapro';
      }
      return currentProduct;
    },
    getTerritoryTypingKpi(territory_id) {
      py.getTerritoryTypingKpi(territory_id).then((res) => {
        if (res && res.value.length) {
          this.summaryData = [
            {
              label: '问卷已填写',
              value: res.value[0].ty_count,
            },
            {
              label: '问卷未填写',
              value: res.value[0].no_ty_count,
            },
            {
              label: '问卷完成度',
              value: (res.value[0].complate_rate * 100).toFixed(2) + '%',
            },
          ];
        }
      });
    },
    getIsSales(user_id) {
      const roleName = getLocalStorage('role_name');
      const salesRoles = ['销售', 'MR', 'DSM', 'RSM', 'RPM', 'MSL', 'GBA', 'GA']; // 定义销售角色
      if (salesRoles.includes(roleName)) {
        this.isSales = 1;
      } else {
        this.isSales = 0;
      }
      this.initPage(user_id);
    },
    changeFn($event) {
      this.searchDoctor();
    },
    confirmFilter() {
      try {
        sessionStorage.setItem('gba_doctor_list_filter', JSON.stringify(this.filterParams));
      } catch (e) {
        console.log(e);
      }
      this.showFilterPopup = false;
      this.searchDoctor();
    },
    resetFilter() {
      this.filterParams = {
        search_key: '',
        is_favorite: [],
        is_covered: [],
        is_wechat: [],
        is_consent: []
      };
      this.confirmFilter();
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/styles/follow-list.scss';
.view-wrapper ::v-deep .cube-index-list-fixed,
.view-wrapper ::v-deep .cube-index-list-anchor {
  text-align: left;
}
.search-bar-list {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 12px;
  // padding-bottom: 10px;
  // background: #fff;
  &.pd-btm0 {
    padding-bottom: 0;
  }
  .search-button {
    font-size: 14px;
    color: #333333;
    width: 50px;
    text-align: center;
    color: #aa341b;
    // position: absolute;
    // right: 20px;
    // top: 10px;
    i {
      font-size: 18px;
      color: #ccc;
    }
  }
}
.search-filter {
  width: 100%;
  padding: 4px 16px 6px 16px;
  // background: #fff;
  box-sizing: border-box;

  .custom-search-bar {
    width: 100%;
    height: 44px;
    background: #fff;
    border-radius: 22px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.02);
    display: flex;
    align-items: center;
    padding: 0 16px;
    border: 1px solid #f5f6f8;
    box-sizing: border-box;

    .search-icon {
      font-size: 18px;
      color: #aa341b;
      margin-right: 8px;
      font-weight: bold;
    }

    .search-input {
      flex: 1;
      border: none;
      outline: none;
      background: transparent;
      font-size: 14px;
      color: #333;
      height: 100%;
      padding: 0;
      margin: 0;
      &::placeholder {
        color: #999;
      }
    }

    .search-content {
      flex: 1;
      display: flex;
      align-items: center;
      overflow: hidden;
      white-space: nowrap;
      height: 100%;
      font-size: 13px;
      color: #333;

      .search-tag {
        background-color: #f0f0f0;
        color: #666;
        padding: 2px 6px;
        border-radius: 4px;
        font-size: 12px;
        margin-right: 4px;
        white-space: nowrap;
      }
    }

    .divider {
      width: 1px;
      height: 16px;
      background-color: #ebedf0;
      margin: 0 12px;
    }

    .reset-action {
      display: flex;
      align-items: center;
      color: #999;
      font-size: 14px;
      cursor: pointer;
      white-space: nowrap;

      .reset-icon {
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}
::v-deep .van-dropdown-menu__bar {
  box-shadow: none;
}
.hcp-list-explain {
  font-size: 11px;
  background-color: #e0e6ed;
  padding: 15px;
  text-align: center;
}
.view-wrapper {
  width: 100%;
  height: 100%;
  // overflow-y: auto;
  // position: relative;
  .add-fav-explain {
    font-size: 14px;
    background-color: #e1f3da;
    padding: 15px 0;
    text-align: center;
  }
  .bac-be {
    height: 30px;
    background-color: #ebebee;
  }
}

.view-wrapper.embedded-mode {
  height: auto;

  .index-list-wrapper {
    height: auto;
    padding: 0;
    overflow: visible;
  }

  .index-list-wrapper.index-list-wrapper-gba {
    height: auto;
    padding-top: 0;
  }

  .index-list-wrapper .van-list {
    padding: 0;
  }

  .hospital-count-div.embedded {
    align-items: center;
    padding: 0 2px 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid #eef1f4;
    font-size: 13px;
    color: #8c939c;
  }

  .hospital-count-div.embedded .f-blod {
    font-size: 16px;
    color: #2f343b;
  }

  ::v-deep .embedded-card.wrapper-item {
    margin-bottom: 10px;
    padding: 0;
    border: 1px solid #eef1f4;
    border-radius: 14px;
    background: linear-gradient(180deg, #ffffff 0%, #fcfcfc 100%);
    box-shadow: 0 6px 18px rgba(15, 23, 42, 0.04);
  }

  ::v-deep .embedded-card.wrapper-item:last-child {
    margin-bottom: 0;
  }

  ::v-deep .embedded-card .custom-item {
    align-items: flex-start;
    padding: 14px 14px 12px;
  }

  ::v-deep .embedded-card .avatar-wrapper {
    width: 52px;
    height: 52px;
    margin: 0;
  }

  ::v-deep .embedded-card .avatar {
    width: 52px;
    height: 52px;
  }

  ::v-deep .embedded-card .custom-item-right {
    padding-left: 12px;
  }

  ::v-deep .embedded-card .name {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    row-gap: 6px;
  }

  ::v-deep .embedded-card .name-w {
    font-size: 16px;
    line-height: 1.3;
    color: #1f2329;
  }

  ::v-deep .embedded-card .tag-nrdl {
    margin: 0 0 0 4px;
    padding: 5px 10px 3px;
    border-radius: 999px;
    font-size: 11px;
    background-color: #fff7f3;
  }

  ::v-deep .embedded-card .tag-kdm {
    margin: 0 0 0 4px;
    padding: 5px 10px 3px;
    border-radius: 999px;
    font-size: 11px;
    color: #aa341b;
    border: 1px solid #aa341b;
    background-color: #fff7f3;
  }

  ::v-deep .embedded-card .department {
    padding: 4px 0 2px;
    color: #70757d;
  }

  ::v-deep .embedded-card .address {
    color: #a0a5ad;
  }

  ::v-deep .embedded-card .hospital {
    line-height: 1.5;
  }
}
.bac-be {
  height: 30px;
  background-color: #ebebee;
}

.loading-state {
  padding: 100px 0 72px;
  text-align: center;
}

.show-more {
  font-size: 12px;
  text-align: center;
  color: #aa341b;
  margin-top: 40px;
  padding-bottom: 60px;
}
.radius-btn {
  border-radius: 20px;

  padding-left: 25px;
  padding-right: 25px;
}
.dimension-icon {
  margin-right: 4px;
}
.custom ::v-deep .name {
  display: flex;
  .name-w {
    // min-width: 60px;
  }
}
.no-list {
  ::v-deep .van-list__finished-text,
  ::v-deep .van-list__placeholder {
    display: none;
  }
}
.online-tab-box {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  .online-tab {
    width: 43%;
    padding: 10px;
    text-align: center;
    border-radius: 4px;
    background-color: #f0f0f0;
    &.active {
      color: #ffffff;
      background-color: #aa341b;
    }
  }
}
.hospital-box {
  .mg-to {
    margin-top: -5px;
  }
  img {
    max-width: 100%;
  }
}
.summary-container {
  display: flex;
  align-items: center;
  justify-content: space-around;

  .summary-item {
    flex: 1;
    padding: 15px 0 0;
    .label {
      font-size: 10px;
      color: #666;
      display: block;
    }
    .value {
      padding: 10px 0 5px;
      display: block;
      font-size: 28px;

      color: #ab351c;
      .v-bd {
        // border-bottom: 1px solid #ab351c;
        font-weight: initial;
      }
    }
  }
}
.van-cps ::v-deep .van-cell__title {
  font-size: 12px !important;
}
.van-cps ::v-deep .van-cell {
  padding-top: 0.166667rem;
  padding-bottom: 0.166667rem;
}
.hospital-count-div {
  display: flex;
  font-size: 12px;
  color: #999;
  padding: 0 0 10px 16px;
  .hospital-count-item + .hospital-count-item {
    margin-left: 10px;
  }
  .f-blod {
    // color: #aa341b;
    font-weight: bold;
  }
}
.f-quest {
  display: flex;
  &.f-quest-mg {
    margin: 0 5px;
  }
  .question-icon {
    color: #aa341b;
    margin-left: 3px;
    // margin-right: 5px;
  }
}
.filter-popup {
  min-height: calc(100vh - 40px);
  padding-top: 40px;
}
.van-checkbox,
.van-radio {
  margin-bottom: 4px;
}
::v-deep .van-radio__icon--checked .van-icon,
::v-deep .van-checkbox__icon--checked .van-icon {
  background-color: #aa341b;
  border-color: #aa341b;
}
.filter-popup ::v-deep .van-cell {
  display: block;
}
::v-deep .van-checkbox-group {
  margin-top: 10px;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}
::v-deep .van-field__label {
  width: 100%;
}
.tab-container {
  padding: 8px 0;
  display: flex;
  justify-content: center;
  position: sticky;
  top: 0;
  z-index: 10;
  background: linear-gradient(180deg, #ffffff 0%, #f4f4f4 100%);
}

.custom-tabs {
  display: flex;
  background: #eef1f6;
  padding: 4px;
  border-radius: 20px;

  .tab-item {
    padding: 6px 32px;
    border-radius: 16px;
    font-size: 14px;
    color: #666;
    font-weight: 500;
    transition: all 0.3s;
    cursor: pointer;

    &.active {
      background: #fff;
      color: #aa341b;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
      font-weight: bold;
    }
  }
}
</style>
